let lazyImageObserver
let lazyVideoObserver

/**
 * @title Initialise
 */
function init() {
  let lazyImages = Array.from(document.querySelectorAll("[data-srcset]"))

  if ("IntersectionObserver" in window) {
    lazyImageObserver = new IntersectionObserver(function (entries) {
      for (let i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          let lazyImage = entries[i].target
          if (lazyImage.dataset.src) lazyImage.src = lazyImage.dataset.src
          if (lazyImage.dataset.srcset) lazyImage.srcset = lazyImage.dataset.srcset
          if (lazyImage.dataset.sizes) lazyImage.sizes = lazyImage.dataset.sizes
          lazyImage.onload = () => {
            lazyImage.classList.add("lazy-loaded")
            lazyImageObserver.unobserve(lazyImage)
          }
        }
      }
    })
    for (let i = 0; i < lazyImages.length; i++) {
      lazyImageObserver.observe(lazyImages[i])
    }
  } else {
    // Possibly fall back to a more compatible method here
    for (let i = 0; i < lazyImages.length; i++) {
      lazyImages[i].src = lazyImages[i].dataset.src
    }
  }
}

/**
 * @title Destroy
 */
function destroy() {
  lazyImageObserver.disconnect()
  lazyVideoObserver.disconnect()
}

export default {
  destroy: destroy,
  init: init,
}
